import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const RedGiant = ({ position, scale = 1 }) => {
    const meshRef = useRef();

    useFrame((state) => {
        const t = state.clock.getElapsedTime();
        // Slow pulsation (dying breath)
        const pulse = 1 + Math.sin(t * 0.5) * 0.05;
        if (meshRef.current) {
            meshRef.current.scale.setScalar(pulse);
            meshRef.current.rotation.y = t * 0.02;
        }
    });

    return (
        <group position={position} scale={scale * 2.0}> {/* Massive scale */}
            <mesh ref={meshRef}>
                <sphereGeometry args={[0.5, 64, 64]} />
                <meshStandardMaterial 
                    color="#ff3300"
                    emissive="#ff0000" // Pure red emission
                    emissiveIntensity={5}
                    roughness={0.6}
                    metalness={0.1}
                />
                <pointLight distance={12} intensity={5} color="#ff4400" decay={2} />
            </mesh>
            {/* Subtle Atmosphere */}
            <mesh scale={1.05}>
                <sphereGeometry args={[0.5, 32, 32]} />
                <meshBasicMaterial 
                    color="#ff0000" 
                    transparent 
                    opacity={0.1} 
                    blending={THREE.AdditiveBlending} 
                    side={THREE.BackSide}
                />
            </mesh>
        </group>
    );
};

export default RedGiant;